import React from "react";
import classNames from "../../utils/classNames";

const noop = () => {};
const defaultProps = {
  type: "text",
  onChange: noop,
};

function InputRate({ className, onChange, ...props }) {
  function onInput(e) {
    let value = e.target.value;

    // Allow only numbers and a single decimal point
    value = value.replace(/[^0-9.]/g, "");

    // Prevent multiple decimal points
    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }

    e.target.value = value;
    onChange(value);
  }

  return (
    <input
      className={classNames("form-control", className)}
      onInput={onInput}
      inputMode="decimal"
      {...props}
    />
  );
}

InputRate.defaultProps = defaultProps;
export default InputRate;
